import * as React from 'react';
import S from './BedroomTabs.styles';
const BedroomTabs = ({ activeIds, onBedroomChange, options }) => {
    const showAll = activeIds.length === 0;
    const handleBedroomChange = (bedroomValue) => {
        if (activeIds.includes(bedroomValue)) {
            onBedroomChange(activeIds.filter((id) => id !== bedroomValue));
        }
        else {
            onBedroomChange([...activeIds, bedroomValue]);
        }
    };
    return (React.createElement(S.Container, null,
        React.createElement(S.Title, null, options.label),
        React.createElement(S.Grid, null,
            React.createElement(S.Tab, { type: "button", "aria-current": showAll, onClick: () => onBedroomChange([]) }, "All"),
            options.options.map((bedroom) => (React.createElement(S.Tab, { key: bedroom.id, "aria-current": activeIds.includes(bedroom.value), onClick: () => handleBedroomChange(bedroom.value), type: "button" }, bedroom.label))))));
};
export default BedroomTabs;
